import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { ChipStatus, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { ApplicationDTO, ApplicationFilterDTO, CompanyDTO, CompanyFilterDTO, TestAgentDTO, UserDTO, ValueListDTO, WorkspaceDTO, WorkspaceFilterDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';

interface ITestAgentMaintenanceProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const TestAgentMaintenance: React.FC<ITestAgentMaintenanceProps> = ({ data, parentId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {
    const [workspaceList, setWorkspaceList] = useState<WorkspaceDTO[]>([]);
    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [testAgentDTO, setTestAgentDTO] = useState<TestAgentDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setTestAgentDTO({
            ...testAgentDTO,
            id: '',
            name: '',
            pathUrl: '',
            description: '',
            applicationId: parentId ?? ''
        } as TestAgentDTO);

        if (isOpenMaintenance) {
            handleListGetAll(ListId.testingsphere.testagent.status, setStatusList);
            handleWorkspaceGetAllAsync();
            handleCompanyGetAllAsync();
            handleUserGetAllAsync();
            handleGetByIdAsync();
        }
    }, [data, isOpenMaintenance]);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);
    }, []);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handleWorkspaceGetAllAsync = useCallback(async () => {
        const workspaceFilterDTO: WorkspaceFilterDTO = {
            name: '',
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllAsync1('testingSphere.workspace', workspaceFilterDTO, setLoading, setWorkspaceList, showMessage);
    }, []);

    const handleCompanyGetAllAsync = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpSphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handleGetByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('testingsphere.testAgent', data.id, setLoading, setTestAgentDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = testAgentDTO as TestAgentDTO;
        if (testAgentDTO?.id === '' || testAgentDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('appsphere.testAgent', dto, setTestAgentDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('appsphere.testAgent', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [testAgentDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        // { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'close', text: 'Close', icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='TEST AGENT DETAILS'
                icon='engineering_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextFieldReadOnly
                                id={'name'}
                                label='Name'
                                value={testAgentDTO?.name}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldReadOnly
                                id={'ipAddress'}
                                label='IP Address'
                                value={testAgentDTO?.ipAddress}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldReadOnly
                                id={'statusId'}
                                label='Status'
                                value={(<ChipStatus label='Status' value={String(statusList.find(x => x.id === testAgentDTO?.statusId)?.value || 'Undefined')} />)}
                                hasDivider={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextFieldReadOnly
                                id={'workspaceId'}
                                label='WorkSpace'
                                value={String(workspaceList.find(x => x.id === testAgentDTO?.workspaceId)?.name)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextFieldReadOnly
                                id={'companyId'}
                                label='Company'
                                value={String(companyList.find(x => x.id === testAgentDTO?.companyId)?.name)}
                            />
                        </Grid>
                        {testAgentDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={testAgentDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === testAgentDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(testAgentDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === testAgentDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(testAgentDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};